<template>
  <div>
    <div>
      <el-form :inline="true" :model="listQuery" class="demo-form-inline">
        <el-form-item label="考试名称:">
          <el-input v-model="listQuery['filter[name]']" clearable placeholder="考试名称"></el-input>

        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="medium" @click="search">查询</el-button>
          <el-button type="success" size="medium" @click="handleAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column prop="id" label="序号">
      </el-table-column>
      <el-table-column prop="name" label="考试名称">
      </el-table-column>
      <el-table-column label="试卷">
        <template slot-scope="scope">
          {{ scope.row.test.name}}
        </template>
      </el-table-column>
      <el-table-column prop="name" label="阅卷老师">
        <template slot-scope="scope">
          {{scope.row.teacher?scope.row.teacher.name:'未选择'}}
        </template>
      </el-table-column>
      <el-table-column prop="start" label="开始时间">
      </el-table-column>
      <el-table-column prop="end" label="结束时间">
      </el-table-column>
      <el-table-column label="操作" width="300">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleStudent(scope)">考生管理</el-button>
          <el-button type="warning" size="mini" @click="handleEdit(scope)">编辑</el-button>
          <el-button type="danger" size="mini" @click="handleDelete(scope)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- v-if="pageform.total>pageform.pageSize" -->

    <div style="text-align: right;margin-top:20px">

      <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.per_page"
                  @pagination="getData"/>

    </div>
    <el-dialog :visible.sync="dialogVisible" :title="dialogType=='new'?'新增考试':'编辑考试'">
      <el-form :model="theory" label-width="100px" label-position="left">
        <el-form-item label="选择考题" v-if="dialogType=='new'">
          <el-select v-model="theory.tid" placeholder="请选择">
            <el-option
              v-for="item in testList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="所属考试" v-if="dialogType=='new'">
          <el-select v-model="theory.exam_id" placeholder="请选择" @change="showName">
            <el-option
              v-for="item in examList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
            <el-option
              :key="0"
              label="无所属考试"
              value="0">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称" prop="name" required style="width: 50%" v-if="nameShow==1||dialogType=='edit'">
          <el-input v-model="theory.name" placeholder="输入名称" v-if="dialogType=='edit'" readonly/>
          <el-input v-model="theory.name" placeholder="输入名称" v-else/>
        </el-form-item>
        <el-form-item label="时长(分钟)" style="width: 50%" v-if="dialogType=='new'" required>
          <el-input v-model="theory.times" placeholder="考试时长"/>
        </el-form-item>
        <el-form-item label="开始时间" required>
          <el-date-picker
            v-model="theory.start"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" required>
          <el-date-picker
            v-model="theory.end"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="阅卷老师" v-if="dialogType=='new'" required>
          <el-select v-model="theory.teacher" placeholder="请选择">
            <el-option
              v-for="item in teacherList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="text-align:right;">
        <el-button type="danger" @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" @click="confirmSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
    import Pagination from '../../components/Pagination'

    export default {
        components: {Pagination},
        props: {},
        data() {
            return {
                theory: {},
                examList: [],
                teacherList: [],
                testList: [],
                nameShow: 0,
                total: 0,
                dialogVisible: false,
                dialogVisible2: false,
                dialogType: 'new',
                listQuery: {
                    page: 1,
                    per_page: 20,
                    include: 'exam,test,teacher'
                },
                tableData: []
            };
        },
        computed: {},
        mounted() {
            this.getData();
        },
        methods: {
            search() {
                this.listQuery.page = 1;
                this.getData()
            },
            showName(value) {
                if (value == 0) {
                    this.nameShow = 1
                } else {
                    this.nameShow = 0
                }
            },
            // 获取全部的课程列表
            getData() {
                this.$http.getTheoryList(this.listQuery)
                    .then(res => {
                        const examList = [];
                        const teacherList = [];
                        const testList = [];
                        res.exam_list.forEach((i) => {
                            examList.push({id: i.id, name: i.name})
                        });
                        res.teacher_list.forEach((i) => {
                            teacherList.push({id: i.id, name: i.name})
                        });
                        res.test_list.forEach((i) => {
                            testList.push({id: i.id, name: i.name})
                        });
                        console.log(examList)
                        console.log(teacherList)
                        console.log(testList)
                        this.tableData = res.data;
                        this.examList = examList;
                        this.teacherList = teacherList;
                        this.testList =testList;
                        this.total = res.meta.total;
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            handleAdd() {
                this.theory = {};
                this.dialogType = 'new';
                this.dialogVisible = true
            },
            handleStudent(scope) {
                this.$router.push({name: 'studentManage', query: {id: scope.row.id}})
            },
            handleEdit(scope) {
                this.dialogType = 'edit';
                this.dialogVisible = true;
                this.$http.getTheory(scope.row.id, {include: 'exam,test'}).then(res => {
                    this.theory = res.data
                })
            },
            confirmSave() {
                const isEdit = this.dialogType === 'edit'
                if (isEdit) {
                    this.$http.updateTheory(this.theory.id, this.theory).then(res => {
                        this.dialogVisible = false
                        this.$notify({
                            title: 'Success',
                            message: '操作成功！',
                            type: 'success'
                        });
                        this.getData()
                    })
                } else {
                    this.$http.addTheory(this.theory).then(res => {
                        this.dialogVisible = false
                        this.$notify({
                            title: 'Success',
                            message: '操作成功！',
                            type: 'success'
                        })
                        this.getData()
                    })
                }
            },
            handleDelete({$index, row}) {
                this.$confirm('确定要删除此条吗?', '警告', {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.$http.deleteTheory(row.id).then(res => {
                            this.tableData.splice($index, 1)
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            })
                        });

                    })
                    .catch(err => {
                        console.error(err)
                    })
            },
        },
    };
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/page/theoryManage/list.vue